<template>
    <div
        class="modal"
        id=""
        tabindex="-1"
        :class="{ event: showModal }"
        ref="modal"
        @keyup.esc="keyUpEvent"
    >
        <transition name="fade" appear>
            <div v-if="showModal" class="fade" />
        </transition>
        <transition name="modal" appear>
            <dialog
                open
                class="modal-dialog"
                :class="[...additionalModalStyle]"
                v-if="showModal"
            >
                <slot name="alert"></slot>
                <header class="modal-header">
                    <slot name="header">
                        <h4 class="modal-title">{{ modalTitle }}</h4>
                    </slot>
                </header>

                <main class="modal-body">
                    <slot name="body">
                        {{ modalDescription }}
                    </slot>
                </main>

                <footer class="modal-footer">
                    <slot name="footer">{{ modalFooter }}</slot>
                </footer>
            </dialog>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'modal',
    description:
        'You can assign the custom options for header and body and footer.',
    props: {
        modalTitle: {
            type: String,
            default: '',
            note: 'set modal title',
        },
        modalDescription: {
            type: String,
            default: '',
            note: 'Assign description in body',
        },
        showModal: {
            type: Boolean,
            default: false,
            note: 'Show or hide modal',
        },
        modalFooter: {
            type: String,
            default: '',
        },
        additionalModalStyle: {
            type: Array,
        },
        keyUpEvent: {
            type: Function,
        },
    },
    mounted() {
        this.$refs.modal.focus();
    },
};
</script>

<style lang="scss" scoped>
.modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    pointer-events: none;

    &:focus {
        outline: none !important;
    }

    .modal-dialog {
        position: static;
        font-size: 14px;
        line-height: 2em;
        background-color: white;
        border: none;
        z-index: 102;
        border-radius: 10px;
        box-sizing: border-box;
    }
    .alert {
        position: relative !important;
        animation: none !important;
    }

    .fade {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.33);
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 101;
    }
    .fade-enter-active {
        transition: opacity 0.3s ease;
    }

    .fade-leave-active {
        transition: opacity 0.3s ease;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .modal-enter-active {
        animation: slide-move 0.3s ease-out;
    }
    .modal-leave-active {
        animation: slide-move 0.3s reverse;
    }

    @keyframes slide-move {
        0% {
            -webkit-transform: translateY(-100%);
        }
        100% {
            -webkit-transform: translateY(0);
        }
    }

    .btn-block {
        margin-top: 0;
    }
    .submit-button-group {
        margin-top: -10px;
    }
}

.event {
    pointer-events: auto;
}
</style>
